import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { GetCountries, GetState, GetCity, GetLanguages, } from "react-country-state-city";
import ArabicKeyboardPopup from "./keyboardpopup";
import { FaKeyboard } from "react-icons/fa";
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';

const PersonalDetails = ({ setTransectionData, transectionData, defaultCountry }) => {

    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [activeField, setActiveField] = useState(null);

    const [countriesList, setCountries] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);

    useEffect(() => {
        GetCountries().then((result) => {
            setCountries(result);
        });
    }, []);
    useEffect(() => {
        GetState(selectedCountry?.value?.id).then((result) => {
            setStateList(result);
        });
    }, [selectedCountry]);
    useEffect(() => {
        GetCity(selectedCountry?.value?.id, selectedState?.value?.id).then((result) => {
            setCityList(result);
        });
    }, [selectedState]);

    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    const handleInputChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    }
    const handleCountryChange = (selectedOption) => {
        setSelectedCountry(selectedOption);
        setSelectedState(null);
        setSelectedCity(null);
    }
    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        setSelectedCity(null);
    }
    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
    }
    const handleKeyboardChange = (value) => {
        setTransectionData(prev => ({
            ...prev,
            [activeField]: value
        }));
    };
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(370px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Type</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData.type}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Mobile No *</label>
                        <div style={{ width: '100%' }}>
                            <PhoneInput 
                                country={defaultCountry}
                                value={transectionData.mobileNo}
                                onChange={(value, country) => {
                                    setTransectionData(prev => ({
                                        ...prev,
                                        mobileNo: value,
                                        countryCode: country.countryCode,
                                    }));
                                }}
                                enableSearch
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Country</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={selectedCountry}
                            onChange={handleCountryChange}
                            options={countriesList?.map(country => ({ value: country, label: country?.name }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Title *</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData.title}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Email ID *</label>
                        <input type="email" className="p-2 form-control w-75" value={transectionData?.email} onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom19" className="form-label">State</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={selectedState}
                            onChange={handleStateChange}
                            options={stateList ? stateList?.map(state => ({ value: state, label: state?.name })) : []}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">First Name</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.firstName} onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Gender *</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.gender} onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">City</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={selectedCity}
                            onChange={handleCityChange}
                            options={cityList ? cityList?.map(city => ({ value: city, label: city?.name })) : []}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Last Name</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.lastName} onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Phone No *</label>
                        <div style={{ width: '75%' }}>
                            <PhoneInput className="p-0"
                                country={defaultCountry}
                                value={transectionData.phoneNo}
                                onChange={(value, country) => {
                                    setTransectionData(prev => ({
                                        ...prev,
                                        phoneNo: value,
                                        countryCode: country.countryCode,
                                    }));
                                }}
                                enableSearch
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Date of Birth</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.dateofBirth}
                            onChange={(date) => handleDateChange({ name: 'dateofBirth', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Full Name *</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.fullName} onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">P.O.Box *</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.poBox} onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Address *</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.address} onChange={handleInputChange} name="stayedPeriod" />
                    </div>
                    <div className="d-flex align-items-center">
                        <label className="form-label w-25">FirstName (AR)</label>
                        <input
                            type="text"
                            dir="rtl"
                            lang="ar"
                            className="form-control"
                            value={transectionData.firstNameAR}
                            onChange={(e) =>
                                setTransectionData(prev => ({
                                    ...prev,
                                    firstNameAR: e.target.value
                                }))
                            }
                            onFocus={() => setActiveField("firstNameAR")}
                        />


                        <FaKeyboard size={30}
                            className="ms-2 keyboard-icon"
                            onClick={() => setActiveField("firstNameAR")}
                        />
                    </div>

                    {/* Last Name AR */}
                    <div className="d-flex align-items-center mt-3">
                        <label className="form-label w-25">LastName (AR)</label>

                        <input
                            type="text"
                            className="form-control"
                            dir="rtl"
                            lang="ar"
                            value={transectionData.lastNameAR}
                            onChange={(e) =>
                                setTransectionData(prev => ({
                                    ...prev,
                                    lastNameAR: e.target.value
                                }))
                            }
                            onFocus={() => setActiveField("lastNameAR")}
                        />

                        <FaKeyboard size={30}
                            className="ms-2 keyboard-icon"
                            onClick={() => setActiveField("lastNameAR")}
                        />
                    </div>

                    {/* Address AR */}
                    <div className="d-flex align-items-center mt-3">
                        <label className="form-label w-25">Address (AR)</label>

                        <input
                            type="text"
                            className="form-control"
                            dir="rtl"
                            lang="ar"
                            value={transectionData.addressAR}
                            onChange={(e) =>
                                setTransectionData(prev => ({
                                    ...prev,
                                    addressAR: e.target.value
                                }))
                            }
                            onFocus={() => setActiveField("addressAR")}
                        />
                        <FaKeyboard size={30}
                            className="ms-2 keyboard-icon"
                            onClick={() => setActiveField("addressAR")}
                        />
                    </div>

                    {/* Keyboard Popup */}
                    {activeField && (
                        <ArabicKeyboardPopup
                            value={transectionData[activeField]}
                            setValue={handleKeyboardChange}
                            onClose={() => setActiveField(null)}
                        />
                    )}
                </div>
            </div>
        </div >
    );
};
export default PersonalDetails;